module.exports = __webpack_public_path__ + "assets/img/4_11_big.659324aa.jpg";